// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // CurrentLinkConnectedProps,
  CurrentLinkMapStateReturnType,
} from './types'

export const CurrentLinkMapState = (): // state: StateReducers,
// props: CurrentLinkConnectedProps,
CurrentLinkMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
